import { useEffect, useRef } from 'react'

import { useStepStore } from '@/stores/step-store/stepStore'

import { smoothScrollTo } from '../utils/smoothScrollTo'

export const useScrollSnapping = () => {
	const currentStep = useStepStore.use.currentStep()
	const stepRef = useRef<string>()

	useEffect(() => {
		setTimeout(() => {
			if (Boolean(stepRef.current) && stepRef.current !== currentStep) {
				smoothScrollTo(currentStep)
			}
			stepRef.current = currentStep
		}, 50)
	}, [currentStep])
}
